'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var returnUrlField = document.querySelector('.return-url-field');
    if (!returnUrlField) return;

    returnUrlField.value = _utils2.default.getQueryStringParam('returnUrl');
};

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/login.js
// module id = 932
// module chunks = 0